// App.js (CORRECTED version)
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import Home from './components/Home';
import Pricing from './components/Pricing';
import Profile from './components/Profile';
import Footer from './components/Footer';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsofService';
import ContentPolicy from './components/ContentPolicy';
import Disclaimer from './components/Disclaimer';
import AboutUs from './components/About';
import CookiePolicy from './components/CookiePolicy';
import WaldoAd from './components/AdComponent';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';

import { calculatorRoutes } from './routes';

// Create lazy-loaded component wrapper
const CalculatorRoute = ({ componentName, title, description, keywords }) => {
  const CalculatorComponent = lazy(() => import(`./components/Pages/${componentName}`));
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <CalculatorComponent />
      </Suspense>
      <WaldoAd />
    </>
  );
};

// Loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Loading calculator...</p>
  </div>
);

// Static route components - FIXED!
const HomeRoute = () => (
  <>
    <Helmet>
      <title>QuickPDFs.net - Free PDF Tools & Document Solutions</title>
      <meta name="description" content="QuickPDFs.net offers free PDF tools to merge, split, compress, and convert PDF documents. Easy-to-use online PDF solutions for all your document needs." />
      <meta name="keywords" content="PDF tools, merge PDF, split PDF, compress PDF, PDF converter, online PDF, free PDF tools, document solutions" />
    </Helmet>
    <Home />
  </>
);

const ProfileRoute = () => (
  <>
    <Helmet>
      <title>Profile - QuickPDFs.net</title>
      <meta name="description" content="Manage your profile settings and preferences on QuickPDFs.net. Customize your PDF tool experience and access your saved documents." />
      <meta name="keywords" content="user profile, account settings, QuickPDFs.net profile, PDF tools preferences, saved documents, user account" />
    </Helmet>
    <Profile /> 
  </>
);

const PricingRoute = () => (
  <>
    <Helmet>
      <title>Pricing - QuickPDFs.net</title>
      <meta name="description" content="Explore pricing plans for QuickPDFs.net. Enjoy free basic PDF tools or upgrade to premium for advanced features, unlimited access, and priority support." />
      <meta name="keywords" content="pricing, PDF tools pricing, QuickPDFs.net plans, premium PDF tools, subscription plans, free vs premium, PDF tool pricing" />
    </Helmet>
    <Pricing /> 
  </>
);

const ContactRoute = () => (
  <>
    <Helmet>
      <title>Contact Us - QuickPDFs.net</title>
      <meta name="description" content="Get in touch with QuickPDFs.net for inquiries, feedback, or support. Our team is here to help with all your PDF tool and document solution questions." />
      <meta name="keywords" content="contact QuickPDFs, customer support, PDF tool inquiries, feedback, PDF tool help, document solution support, PDF converter assistance" />
    </Helmet>
    <Contact />
  </>
);

const PrivacyPolicyRoute = () => (
  <>
    <Helmet>
      <title>Privacy Policy - QuickPDFs.net</title>
      <meta name="description" content="Read the Privacy Policy of QuickPDFs.net to understand how we collect, use, and protect your data while using our PDF tools and document solutions." />
      <meta name="keywords" content="privacy policy, data protection, QuickPDFs.net, user privacy, website privacy policy, PDF tools privacy" />
    </Helmet>
    <PrivacyPolicy />
  </>
);

const TermsOfServiceRoute = () => (
  <>
    <Helmet>
      <title>Terms of Service - QuickPDFs.net</title>
      <meta name="description" content="Read the Terms of Service of QuickPDFs.net to understand the rules, responsibilities, and legal agreements for using our PDF tools and document solutions." />
      <meta name="keywords" content="terms of service, user agreement, QuickPDFs.net, website terms, legal terms, PDF tools terms" />
    </Helmet>
    <TermsOfService />
  </>
);

const DisclaimerRoute = () => (
  <>
    <Helmet>
      <title>Disclaimer - QuickPDFs.net</title>
      <meta name="description" content="Read the Disclaimer of QuickPDFs.net to understand the limitations, accuracy, and responsibilities regarding the use of our PDF tools and document solutions." />
      <meta name="keywords" content="disclaimer, PDF tools disclaimer, QuickPDFs.net, liability, accuracy of information, document tools disclaimer" />
    </Helmet>
    <Disclaimer /> 
  </>
);

const ContentPolicyRoute = () => (
  <>
    <Helmet>
      <title>Content Policy - QuickPDFs.net</title>
      <meta name="description" content="Read the Content Policy of QuickPDFs.net to understand the guidelines for using and sharing content on our website, including PDF tools and document solutions." />
      <meta name="keywords" content="content policy, website content guidelines, QuickPDFs.net, content usage, content rules, PDF tools content" />
    </Helmet>
    <ContentPolicy />
  </>
);

const AboutUsRoute = () => (
  <>
    <Helmet>
      <title>About Us - QuickPDFs.net</title>
      <meta name="description" content="Learn more about QuickPDFs.net, our mission, team, and how we provide free PDF tools and document solutions to help users manage their files efficiently." />
      <meta name="keywords" content="About QuickPDFs.net, PDF tools team, document solutions, company information, About Us, free PDF tools" />
    </Helmet>
    <AboutUs /> 
  </>
);

const CookiePolicyRoute = () => (
  <>
    <Helmet>
      <title>Cookie Policy - QuickPDFs.net</title>
      <meta name="description" content="Read the Cookie Policy of QuickPDFs.net to understand how we use cookies and similar technologies to improve your experience and provide personalized PDF tool services." />
      <meta name="keywords" content="Cookie Policy, QuickPDFs.net cookies, website cookies, privacy, cookie usage, cookie management, PDF tools cookies" />
    </Helmet>
    <CookiePolicy /> 
  </>
);

const SignInRoute = () => (
  <>
    <Helmet>
      <title>Cookie Policy - QuickPDFs.net</title>
      <meta name="description" content="Read the Cookie Policy of QuickPDFs.net to understand how we use cookies and similar technologies to improve your experience and provide personalized PDF tool services." />
      <meta name="keywords" content="Cookie Policy, QuickPDFs.net cookies, website cookies, privacy, cookie usage, cookie management, PDF tools cookies" />
    </Helmet>
    <SignIn /> 
  </>
);

const SignUpRoute = () => (
  <>
    <Helmet>
      <title>Cookie Policy - QuickPDFs.net</title>
      <meta name="description" content="Read the Cookie Policy of QuickPDFs.net to understand how we use cookies and similar technologies to improve your experience and provide personalized PDF tool services." />
      <meta name="keywords" content="Cookie Policy, QuickPDFs.net cookies, website cookies, privacy, cookie usage, cookie management, PDF tools cookies" />
    </Helmet>
    <SignUp /> 
  </>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Static Routes */}
              <Route path="/" element={<HomeRoute />} />
              <Route path="/Pricing" element={<PricingRoute />} />
              <Route path="/Profile" element={<ProfileRoute />} />
              <Route path="/SignUp" element={<SignUpRoute />} />
              <Route path="/SignIn" element={<SignInRoute />} />
              <Route path="/Contact" element={<ContactRoute />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicyRoute />} />
              <Route path="/TermsOfService" element={<TermsOfServiceRoute />} />
              <Route path="/Disclaimer" element={<DisclaimerRoute />} />
              <Route path="/ContentPolicy" element={<ContentPolicyRoute />} />
              <Route path="/AboutUs" element={<AboutUsRoute />} />
              <Route path="/CookiePolicy" element={<CookiePolicyRoute />} />
              
              {/* Dynamic Calculator Routes */}
              {calculatorRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <CalculatorRoute
                      componentName={route.component}
                      title={route.title}
                      description={route.description}
                      keywords={route.keywords}
                    />
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;